<template>
  <div>
    <div :class="generateClassName(index)" v-for="(item,index) in dataList" :key="index" @click="getClick(index,item)">
      <van-image width="10%" fit="cover" :src="require('../../assets/image/mem.png')"
                 class="q_veralign_middle"/>
      <span class="q_inlineblock q_veralign_middle q_text_m q_mar_l10px" v-text="getTxt(item.chargeType)">1年队费</span>
      <span class="q_flo_right q_bold">￥{{ item.money }}</span>
    </div>
    <!-- <div class="q_mem_con q_mem_coned">
      <van-image width="10%" fit="cover" :src="require('../../assets/image/mem.png')"
        class="q_veralign_middle" />
      <span class="q_inlineblock q_veralign_middle q_text_m q_mar_l10px">1年队费</span>
      <span class="q_flo_right q_bold">免费</span>
    </div>
    <div class="q_mem_con">
      <van-image width="10%" fit="cover" :src="require('../../assets/image/mem.png')"
        class="q_veralign_middle" />
      <span class="q_inlineblock q_veralign_middle q_text_m q_mar_l10px">5年队费</span>
      <span class="q_flo_right q_bold">￥10.00</span>
    </div> -->

    <van-goods-action>
      <div style="width: 50%;">
        <span class="q_mar_l15px">支付：</span>
        <span class="q_bold q_color_red">{{ money }}元</span>
      </div>
      <van-goods-action-button type="danger" color="#FF5733" text="确认支付" @click="submitFee"/>
    </van-goods-action>
  </div>
</template>

<script>
import {selectSysDeptFeeByDeptId} from "@/api/userDept.js";
import {getLoginUser} from "@/api/login";
import {abcPay} from "@/api/pay";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Member',
  props: {
    msg: String
  },
  created() {
    wxCloseShare()
    this.id = this.$route.query.id;
    getLoginUser().then(res => {
      console.log(res.data.baseAudit)
      this.user = res.data
    }).then(() => {
      this.initData();
    })
  },
  data() {
    return {
      id: '',
      dataList: [],
      action: '',
      money: '',
      currentItem: {},
      user: {}
    }
  },
  methods: {
    generateClassName(index) {
      if (this.action == index) {
        return "q_mem_con q_mem_coned";
      } else {
        return "q_mem_con";
      }
      return `game_item-${index}`
    },

    getClick(index, item) {
      this.action = index;
      this.money = item.money
      this.currentItem = item
    },
    getTxt(chargeType) {
      if ("1" == chargeType) {
        return "一年队费"
      } else if ("2" == chargeType) {
        return "一季度队费"
      } else if ("3" == chargeType) {
        return "一个月队费"
      } else if ("0" == chargeType) {
        return "永久队费"
      }
    },
    initData() {
      var data = {
        deptId: this.id
      }
      selectSysDeptFeeByDeptId(data).then(res => {
        this.dataList = res.data;
        if (this.dataList.length > 0) {
          this.getClick(0, this.dataList[0])
        }
      })
    },
    /**
     * 缴费按钮
     */
    submitFee() {
      this.$modal.loading('正在支付...')
      abcPay('2', this.currentItem.id, this.money).then((res) => {
        if (res.code == 200) {
          this.$modal.closeLoading()
          if (res.payUrl!=null){
            window.location.href = res.payUrl
          }else {
            this.$modal.success("缴费成功");
            //定时1.5秒返回上一页
            setTimeout(() => {
              this.$modal.closeLoading()
              //返回上一页
              window.history.go(-1)
            }, 1500);
          }
        }
      })
    }
  },
}
</script>
<style scoped="scoped">
.q_mem_con {
  padding: 10px 15px;
  background-color: #F2F3F7;
  margin: 15px;
  border-radius: 10px;
}

.q_mem_coned {
  background-color: rgba(255, 214, 200, .6);
  color: #FF5733;
}

.van-goods-action {
  box-shadow: 0 0 10px #f2f3f7;
  height: 60px;
}
</style>
